import { useParams } from 'react-router-dom';

type InventoryUrl = {
  inventoryId: string;
};

const useInventoryId = () => {
  const params = useParams<InventoryUrl>();
  return Number(params.inventoryId);
};

export { useInventoryId };
